module.exports = __webpack_public_path__ + "img/img-2.1e7daf8a.png";